export enum BillingType {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}
